var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import BasicProfileURL from "@adapters/infrastructures/urlConfig/BasicProfile/BasicProfileConfigURL";
import clientDetailsMapper from "@domains/features/BasicProfile/Mapper/clientDetailsMapper";
import getRegisterdDevicMapper from "@domains/features/BasicProfile/useCases/getRegisteredDevicesMapper";
import { MandateURL } from "@adapters/infrastructures/urlConfig/Mandate/MandateUrl";
import { accountDetails } from "../../../../mainDi/webDi";
import { encryptionEnable } from "@adapters/infrastructures/encryption";
var BasicDetailsRepository = /** @class */ (function () {
    function BasicDetailsRepository(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    BasicDetailsRepository.prototype.getClientcategoryNRI = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var userID, accTyp, url, AllClientNRIData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getUserID()];
                    case 1:
                        userID = _b.sent();
                        return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getPreferedAccountCodeID())];
                    case 2:
                        accTyp = (_b.sent()).accTyp;
                        url = new URL(BasicProfileURL.clientNRIUrl);
                        url.searchParams.append("accTyp", accTyp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 3:
                        AllClientNRIData = _b.sent();
                        return [2 /*return*/, AllClientNRIData];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.getClientDetailsData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var userID, _b, accCode, accTyp, url, AllClientDetails;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getUserID()];
                    case 1:
                        userID = _c.sent();
                        return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getPreferedAccountCodeID())];
                    case 2:
                        _b = _c.sent(), accCode = _b.accCode, accTyp = _b.accTyp;
                        url = new URL(BasicProfileURL.clientDetails);
                        url.searchParams.append("accountId", userID);
                        url.searchParams.append("accTyp", accTyp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 3:
                        AllClientDetails = _c.sent();
                        return [2 /*return*/, clientDetailsMapper(AllClientDetails)];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.advisorRatingDetailsData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, AllAdvisorDetails;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getPreferedAccountCodeID())];
                    case 1:
                        accountCode = _b.sent();
                        url = new URL(BasicProfileURL.advisorRating + (accountCode === null || accountCode === void 0 ? void 0 : accountCode.accCode));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 2:
                        AllAdvisorDetails = _b.sent();
                        return [2 /*return*/, AllAdvisorDetails === null || AllAdvisorDetails === void 0 ? void 0 : AllAdvisorDetails.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.getDeviceRegisterDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var prfid, url, GetAllDevicesList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prfid = req.prfId;
                        url = new URL(BasicProfileURL.getRegisteredDevices + "/" + prfid);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        GetAllDevicesList = _a.sent();
                        return [2 /*return*/, getRegisterdDevicMapper(GetAllDevicesList)];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.getProfilePicData = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, GetProfilePicDetails;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getPreferedAccountCodeID())];
                    case 1:
                        accountCode = _b.sent();
                        url = new URL(BasicProfileURL.getProfilePicture);
                        url.searchParams.append("accountId", accountCode.accCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        GetProfilePicDetails = _b.sent();
                        return [2 /*return*/, GetProfilePicDetails.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.registerDeviceDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, RegisterDevicesList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.deviceRegister);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        RegisterDevicesList = _a.sent();
                        return [2 /*return*/, RegisterDevicesList.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.saveProfilePicData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, saveProfilePicDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.saveprofilepicture);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.savepicbody,
                            })];
                    case 1:
                        saveProfilePicDetails = _a.sent();
                        return [2 /*return*/, saveProfilePicDetails.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.deleteProfilePicData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, deleteProfilePicDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.deleteProfilePicture);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "DELETE",
                                url: url.toString(),
                                body: req.savepicbody,
                            })];
                    case 1:
                        deleteProfilePicDetails = _a.sent();
                        return [2 /*return*/, deleteProfilePicDetails.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.deRegisterDeviceDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, DeregisterDevicesList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.deRegisterDevice);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        DeregisterDevicesList = _a.sent();
                        return [2 /*return*/, DeregisterDevicesList.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.nomineeDetailsData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accTyp, url, NomineeDetails;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getPreferedAccountCodeID())];
                    case 1:
                        accTyp = _b.sent();
                        url = new URL(BasicProfileURL.nomineeDetails);
                        url.searchParams.append("accTyp", accTyp === null || accTyp === void 0 ? void 0 : accTyp.accTyp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        NomineeDetails = _b.sent();
                        return [2 /*return*/, NomineeDetails.data.value];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.getBrokerageSegmentData = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, AllDetails;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getPreferedAccountCodeID())];
                    case 1:
                        accountCode = _b.sent();
                        url = new URL(BasicProfileURL.getBrokerageSegments);
                        url.searchParams.append("accountId", accountCode === null || accountCode === void 0 ? void 0 : accountCode.accCode);
                        url.searchParams.append("accType", accountCode === null || accountCode === void 0 ? void 0 : accountCode.accTyp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        AllDetails = _b.sent();
                        return [2 /*return*/, AllDetails.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.getRmDetailsData = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, AllRmDetails;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getPreferedAccountCodeID())];
                    case 1:
                        accountCode = _b.sent();
                        url = new URL(BasicProfileURL.getRmDetails);
                        url.searchParams.append("accountId", accountCode === null || accountCode === void 0 ? void 0 : accountCode.accCode);
                        url.searchParams.append("accType", accountCode === null || accountCode === void 0 ? void 0 : accountCode.accTyp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        AllRmDetails = _b.sent();
                        return [2 /*return*/, AllRmDetails];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.whatsappContentDetailsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, WhatsappDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.whatsappConsent);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        WhatsappDetails = _a.sent();
                        return [2 /*return*/, WhatsappDetails === null || WhatsappDetails === void 0 ? void 0 : WhatsappDetails.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.downloadKYC = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.downloadKYCData);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.defaultExchangeData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, exchangedata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.defaultExchange);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        exchangedata = _a.sent();
                        return [2 /*return*/, exchangedata];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.wealthAdvisorData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accountCode, url, wealthdata;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getPreferedAccountCodeID())];
                    case 1:
                        accountCode = _b.sent();
                        url = new URL(BasicProfileURL.wealthAdvisor);
                        url.searchParams.append("accountId", accountCode.accCode);
                        url.searchParams.append("accType", accountCode.accTyp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        wealthdata = _b.sent();
                        return [2 /*return*/, wealthdata];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.saveLeadData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, saveleaddata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.savelead);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        saveleaddata = _a.sent();
                        return [2 /*return*/, saveleaddata];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.mandateCalendarData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, mandateCalendardata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(MandateURL.mandateCalendar);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: {
                                    clientCode: req.userId,
                                    startDt: req.stDt,
                                    mandateId: req.mandateId,
                                },
                                // encryption: encryptionEnable,
                            })];
                    case 1:
                        mandateCalendardata = _a.sent();
                        return [2 /*return*/, mandateCalendardata];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.deleteUpiData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var userId, url, deleteUpiDetails;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, accountDetails.getUserID()];
                    case 1:
                        userId = _a.sent();
                        url = new URL(BasicProfileURL.deleteUpi + userId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "DELETE",
                                url: url.toString(),
                                body: req,
                            })];
                    case 2:
                        deleteUpiDetails = _a.sent();
                        return [2 /*return*/, deleteUpiDetails.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.generateSecretKeyEtotp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, secretKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.generateSecretKeyEtotp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: undefined,
                            })];
                    case 1:
                        secretKey = _a.sent();
                        return [2 /*return*/, secretKey.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.validateSecretKeyEtotp = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.validateSecretKeyEtotp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.validatePasswordDisableEtotp = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var acc, url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, accountDetails.getPreferedAccountCodeID()];
                    case 1:
                        acc = _a.sent();
                        url = new URL("".concat(BasicProfileURL.passwordVerifyDisableEtotp, "/").concat(acc === null || acc === void 0 ? void 0 : acc.accCode));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 2:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.disableEtotp = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(BasicProfileURL.disableEtotp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.disableEtotpGenerateOtp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var acc, url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, accountDetails.getPreferedAccountCodeID()];
                    case 1:
                        acc = _a.sent();
                        url = new URL("".concat(BasicProfileURL.disableEtotpGenerateOtp, "/").concat(acc.accCode));
                        url.searchParams.append("acTyp", acc.accTyp);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 2:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.changePassword = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var acc, url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, accountDetails.getPreferedAccountCodeID()];
                    case 1:
                        acc = _a.sent();
                        url = new URL("".concat(BasicProfileURL.changePassword, "/").concat(acc.accCode, "/changepassword/v1"));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 2:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        });
    };
    BasicDetailsRepository.prototype.mandateLinkedSip = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, request, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(MandateURL.mandateLinkedSip);
                        request = {
                            mandateId: req.mandateId,
                        };
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                // method: "GET",
                                url: url.toString(),
                                encryption: encryptionEnable,
                                body: request,
                            })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp];
                }
            });
        });
    };
    return BasicDetailsRepository;
}());
export default BasicDetailsRepository;
